// extracted by mini-css-extract-plugin
module.exports = {"frame":"LandingView_frame__3aBZj","wrapper":"LandingView_wrapper__Jj39e","container-width":"LandingView_container-width__2WX2S"};